/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_By_SpeakersInputs */

const en_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge by Speakers`)
};

const fr_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner par locuteurs`)
};

const de_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführung nach Sprechern`)
};

const it_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci per relatori`)
};

const ru_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние по спикерам`)
};

const es_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusión por oradores`)
};

const zh_cn2_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按发言人合并`)
};

const ja_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーによるマージ`)
};

const hi_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं के आधार पर विलय करें`)
};

const pt_pt2_event_group_options_merge_by_speakers = /** @type {(inputs: Event_Group_Options_Merge_By_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão por Oradores`)
};

/**
* | output |
* | --- |
* | "Merge by Speakers" |
*
* @param {Event_Group_Options_Merge_By_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_by_speakers = /** @type {((inputs?: Event_Group_Options_Merge_By_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_By_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_merge_by_speakers(inputs)
	if (locale === "de") return de_event_group_options_merge_by_speakers(inputs)
	if (locale === "it") return it_event_group_options_merge_by_speakers(inputs)
	if (locale === "ru") return ru_event_group_options_merge_by_speakers(inputs)
	if (locale === "es") return es_event_group_options_merge_by_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_merge_by_speakers(inputs)
	if (locale === "ja") return ja_event_group_options_merge_by_speakers(inputs)
	if (locale === "hi") return hi_event_group_options_merge_by_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_merge_by_speakers(inputs)
	return en_event_group_options_merge_by_speakers(inputs)
});